/**
 * Sticky add-to-cart bar for product pages — ALWAYS-VISIBLE variant.
 *
 * Deployed as assets/mz-sticky.js in "Thriftizer_Magic Checkout" (187229536566).
 * Other themes run assets/mz-sticky.js (the scroll-triggered variant); the two
 * differ only in when the bar is shown.
 *
 * The bar is present from page load and stays for the whole visit, so Add to
 * Cart is always one tap away. It is only ever built on product pages, because
 * main-product.liquid is the only file that loads this script.
 *
 * Carries the 2026-07-31 fixes: pick the real add-to-cart form (NOT the Shop Pay
 * installment form, which `form[action$="/cart/add"]` matches first and which has
 * no .product-form__submit, making the button silently no-op), and toggle
 * `mz-sticky-open` on <body> so CSS can lift the floating WhatsApp button clear.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action$="/cart/add"]'));
    var form =
      document.querySelector('form[action$="/cart/add"][data-type="add-to-cart-form"]') ||
      forms.filter(function (f) { return f.querySelector('.product-form__submit'); })[0];
    if (!form) return;

    var submit = form.querySelector('.product-form__submit');
    if (!submit) return;

    var title = document.querySelector('.product__title');
    var priceEl = document.querySelector('.mz-price__sale');
    var img = document.querySelector('.product__media-gallery img,.product__media img');
    var mobile = window.innerWidth <= 749;
    if (!title || !priceEl) return;

    var bar = document.createElement('div');
    bar.className = 'mz-sticky';
    if (!mobile) {
      bar.innerHTML =
        (img ? '<img class="mz-sticky__img" src="' + img.src + '" alt="">' : '') +
        '<div class="mz-sticky__info"><p class="mz-sticky__name">' +
        (title.textContent || '').trim().slice(0, 50) +
        '</p><p class="mz-sticky__price">' + (priceEl.textContent || '') + '</p></div>';
    }
    bar.innerHTML +=
      '<button type="button" class="mz-sticky__btn"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>ADD TO CART</button>' +
      '<button type="button" class="mz-sticky__wish" aria-label="Wishlist"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg></button>';
    document.body.appendChild(bar);

    bar.querySelector('.mz-sticky__btn').addEventListener('click', function () {
      submit.click();
    });

    var mainWish = document.querySelector('.mz-wish');
    var stickyWish = bar.querySelector('.mz-sticky__wish');
    stickyWish.addEventListener('click', function () {
      stickyWish.classList.toggle('wished');
      if (mainWish) {
        mainWish.classList.toggle('wished');
        var svg = mainWish.querySelector('path');
        if (svg) svg.setAttribute('fill', mainWish.classList.contains('wished') ? '#a3188c' : 'none');
      }
    });

    // Show immediately and keep it up. Two frames so the slide-up transition
    // still plays rather than the bar snapping into place.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        bar.classList.add('show');
        document.body.classList.add('mz-sticky-open');
      });
    });
  });
})();
